document.addEventListener('DOMContentLoaded', function() {
  // 1. Fetch resources
  const inputs = document.querySelectorAll('.js-ctm-click-simulator.js-product-option');

  // 2. Fail-Fast Validation
  if (!inputs || inputs.length < 2) { console.warn("System Error: Insufficient inputs found for click simulation."); return; }

  let activeItem = null;
  let dummyItem = null;

  // 3. Single-Pass Execution (O(n))
  for (let i = 0; i < inputs.length; i++) {
      const item = inputs[i];
      if (item.checked) { activeItem = item; } 
      else if (dummyItem === null) { dummyItem = item; }
      if (activeItem !== null && dummyItem !== null) { break; }
  }

  // 4. Execution Logic
  if (activeItem && dummyItem) {
      dummyItem.click();
      activeItem.click();
      console.log("Initialization: Input state refreshed.");
  } else { console.warn("Logic Error: Could not identify an active input to preserve."); }
});


document.addEventListener('DOMContentLoaded', function(){
  let listItems = document.querySelectorAll('.ctm_featured-products__items product-thumbnail');
  if (listItems.length > 0) {
      listItems.forEach((listItem)=>{
          // console.log(listItem)
          listItem.querySelector('.product-thumb__variants input[type="radio"]').checked = true;
      })
  }

  $(document).ready(function(){
    if (window.matchMedia('(max-width: 768px)').matches) {
      // .ctm__promo_slider
      $('.ctm__promo_slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2000,
        prevArrow: `<svg class="slick-prev slick-arrow" aria-hidden="true" focusable="false" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7925 19.915L5.39581 11.5L13.7925 3.085L11.2075 0.5L0.207479 11.5L11.2075 22.5L13.7925 19.915Z" fill="#000000"/></svg>`,
        nextArrow: `<svg class="slick-next slick-arrow" aria-hidden="true" focusable="false" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.20752 19.915L8.60419 11.5L0.20752 3.085L2.79252 0.5L13.7925 11.5L2.79252 22.5L0.20752 19.915Z" fill="#000000"/></svg>`
      })
    }
  })

})

function ftrUpsellChange() {
  const ftrVarID = document.querySelector(".cus_ftr_up_product").getAttribute("data-vID");
  const cartProductVarID = document.querySelectorAll(".cus_cart_item");

  const itemInCart = Array.from(cartProductVarID).find(cartid => ftrVarID == cartid.getAttribute("data-pro-id"));

  if (itemInCart) {
    const removeBtn = itemInCart.querySelector(".cus_remove_btn");
    if (removeBtn) {
      removeBtn.click();
      // console.log("Removed from cart");
    }
  } else {
    const ftrUpsellATC = document.querySelector(".cus-ftr-upsell-atc");
    if (ftrUpsellATC) {
      ftrUpsellATC.click();
      // console.log("Added to cart");
    }
  }
}

document.addEventListener("change", (e) => {
  // console.log('Change event detected');
  let item = e.target;
  if (item.closest(".ftr_upsell_inp")) {
    ftrUpsellChange();
  }
});

//*********    alt based image selection     ********** 

document.addEventListener("DOMContentLoaded", function () {
  const optionInputs = document.querySelectorAll('.js-ctm-var-inp');
  const gallerySlides = document.querySelectorAll('.product-gallery__slide');

  function getSelectedSize() {
    const checkedOption = document.querySelector('.js-ctm-var-inp:checked');
    return checkedOption?.value?.trim() || null;
  }

  function filterImagesBySize(size) {
    
    gallerySlides.forEach(slide => {
      const img = slide.querySelector('picture img');
      const alt = img?.getAttribute('alt') || '';

      // if (alt.includes(size)) {
      if (alt.toLowerCase().includes(size.toLowerCase())) {
        slide.style.display = 'block';
      } else {
        slide.style.display = 'none';
      }
    });
  }

  const initialSize = getSelectedSize();

  if (initialSize) { filterImagesBySize(initialSize) }

  optionInputs.forEach(input => {
    input.addEventListener('change', function () {
      const newSize = this.value;
      filterImagesBySize(newSize);
    });
  });
});



